import useScrollProgress from "@/hooks/useScrollProgress";

/**
 * Two-pixel reading-position bar pinned to the top edge.
 *
 * Decorative: it duplicates what the native scrollbar already tells assistive
 * tech, so it is aria-hidden. z-[60] is required — PublicLayout’s header is
 * sticky z-50 and would otherwise cover it on every marketing page.
 */
export default function ScrollProgressBar() {
  const { progress, isScrollable } = useScrollProgress();

  if (!isScrollable) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] h-0.5 pointer-events-none"
      aria-hidden="true"
      data-testid="scroll-progress-bar"
    >
      <div
        className="h-full bg-brand"
        style={{ width: `${progress * 100}%` }}
        data-testid="scroll-progress-fill"
      />
    </div>
  );
}
